import React from 'react';
import Breadcrumb from '../components/Common/Breadcrumb';
import { Link } from 'react-router-dom';

const Feature = () => {
  const features = [
    {
      id: 1,
      icon: 'fas fa-dollar-sign',
      title: 'Cost-Effective',
      description: 'Dolor, sit amet consectetur adipisicing elit. Soluta inventore cum accusamus,'
    },
    {
      id: 2,
      icon: 'fab fa-cc-visa',
      title: 'Visa Assistance',
      description: 'Dolor, sit amet consectetur adipisicing elit. Soluta inventore cum accusamus,'
    },
    {
      id: 3,
      icon: 'fas fa-clock',
      title: 'Fast Processing',
      description: 'Dolor, sit amet consectetur adipisicing elit. Soluta inventore cum accusamus,'
    },
    {
      id: 4,
      icon: 'fas fa-shield-alt',
      title: 'Secure & Reliable',
      description: 'Dolor, sit amet consectetur adipisicing elit. Soluta inventore cum accusamus,'
    }
  ];

  return (
    <>
      <Breadcrumb title="Features" />
      <div className="container-fluid features overflow-hidden py-5">
        <div className="container">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Why Choose Us</h5>
            </div>
            <h1 className="display-5 mb-4">Offer Tailor Made Services That Our Client Requires</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus, eius nam mollitia voluptas maxime veniam necessitatibus saepe in ab? Repellat!</p>
          </div>
          <div className="row g-4 justify-content-center text-center">
            {features.map((feature, index) => (
              <div key={feature.id} className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                <div className="feature-item text-center p-4">
                  <div className="feature-icon p-3 mb-4">
                    <i className={`${feature.icon} fa-4x text-primary`}></i>
                  </div>
                  <div className="feature-content d-flex flex-column">
                    <h5 className="mb-3">{feature.title}</h5>
                    <p className="mb-3">{feature.description}</p>
                    <Link className="btn btn-secondary rounded-pill" to={`/feature/${feature.id}`}>Read More<i className="fas fa-arrow-right ms-2"></i></Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Feature; 